import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { StringFormatPipe } from '../../pipe/string.format.pipe';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../pipe/string.format.pipe";
/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var CopyService = /** @class */ (function () {
    /**
     * Constructor de la clase
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @var {HttpClient} _http
     * @var {StringFormatPipe} stringFormat
     */
    function CopyService(_http, stringFormat) {
        this._http = _http;
        this.stringFormat = stringFormat;
    }
    /**
     * Función para cargar las copias que están guardadas en ./assets/resources/copies.json
     *
     * *Function to load copies saved in ./assets/resources/copies.json*
     *
     * @type {function}
     * @param {string} customURL
     */
    CopyService.prototype.loadCopies = function (customURL) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (customURL === undefined) {
                            url = './assets/resources/copies.json';
                        }
                        else {
                            url = customURL;
                        }
                        return [4 /*yield*/, this._http.get(url).toPromise().then(function (response) {
                                _this.copies = response['data'].copies;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función para obtener las copias que están guardadas en ./assets/resources/copies.json
     *
     * *Function to obtain copies saved in ./assets/resources/copies.json*
     *
     * @type {function}
     * @param {string} copyName
     * @returns {string}
     */
    CopyService.prototype.getCopy = function (copyName) {
        return this.copies[copyName];
    };
    /**
     * Función para obtener las copias parametrizadas que están guardadas en ./assets/resources/copies.json
     *
     * *Function to obtain parametrized copies saved in ./assets/resources/copies.json*
     *
     * @type {function}
     * @param {string} copyName
     * @returns {string}
     */
    CopyService.prototype.getParametrizedCopy = function (copyName, parameters, fatherCopyName) {
        var copy = fatherCopyName ? this.copies[fatherCopyName][copyName] : this.copies[copyName];
        return this.stringFormat.transform(copy, parameters);
    };
    CopyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CopyService_Factory() { return new CopyService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.StringFormatPipe)); }, token: CopyService, providedIn: "root" });
    return CopyService;
}());
export { CopyService };
